// src/pages/Projects.jsx
import React from 'react';
import projects from '../constants/projects';
import ProjectCard from '../components/ProjectCard';
import './Projects.css';

function Projects() {
  return (
    <section className="projects" id="projects">
      <div className="projects__container">
        <div className="projects__header">
          <h2 className="projects__title">
            <span className="projects__title-text">My Projects</span>
          </h2>
          <p className="projects__subtitle">
            Here are some of my recent works
          </p>
        </div>
        <div className="projects__grid">
          {projects.map((project, index) => (
            <ProjectCard
              key={project.id}
              title={project.title}
              description={project.description}
              link={project.link}
              image={project.image}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;